import * as React from 'react'
// components
import Header from '../components/layouts/Header'
import Footer from '../components/layouts/Footer'
import AgenciesData from '../components/sections/Agencies'

const Agencies = () => (
  <>
    <div id='smooth-wrapper'>
      <div id='smooth-content'>
        <div className='podio agencies-wrapper'>
          <AgenciesData />
          <Footer />
        </div>
      </div>
    </div>
    <Header />
  </>
)

export default Agencies
